import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'tabLink', 'tabContent' ];

  show(event) {
    event.preventDefault();
    const target = event.target;

    for (let tab of this.tabLinkTargets) {
      tab.classList.remove('active');
    }

    for (let tab of this.tabContentTargets) {
      tab.classList.remove('active');
    }

    target.classList.add('active');
    document.querySelector(target.dataset.country).classList.add('active');
  }

  mobileTab(event) {
    event.preventDefault();
    const target = event.target;
    const tabTarget = target.options[target.selectedIndex].dataset.country;

    if (tabTarget === 'international') {
      window.location.href = target.options[target.selectedIndex].value;
      return;
    }

    for (let tab of this.tabContentTargets) {
      tab.classList.remove('active');
    }
    document.querySelector(tabTarget).classList.add('active');
  }
}
